import { inject, Injectable } from '@angular/core';
import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/authentication/auth.service';
import { UserRole } from '../utils/constants';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currUser = this.authService.userInfo?.user;
    console.log(currUser);
    if (currUser == null) {
      this.router.navigate(['/login']);
      return false;
    }
    // console.log("Route")
    // console.log(route)
    if (currUser.role != null) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
